import { useRef } from 'react';
import { useEffect } from 'react';

const usePrevious = (value) => {
  const ref = useRef();
  useEffect(() => {
      ref.current = value;
  });
  return ref.current;
};

export default usePrevious;
